export const feedbackTextSuggestions = [
  {
    name: "PPA Aprovado",
    text: `
      Parabéns! Você foi aprovado na etapa XXX do seu projeto prático. Você atendeu a todos os critérios necessários com excelência.

      Aqui estão alguns pontos que merecem destaque:

      Clareza e Objetividade: Sua apresentação foi clara e objetiva, facilitando a compreensão do projeto.

      Execução: Demonstraram um bom domínio do conteúdo e foram aplicadas de maneira eficaz.

      Documentação: A documentação foi bem elaborada, permitindo um bom acompanhamento do seu raciocínio e das etapas realizadas.
    `,
    helper: "Alterar onde tiver XXX"
  },
  {
    name: "PPA Reprovado",
    text: `
      Após a análise, preciso informar que você não foi aprovado na etapa XXX.

      Alguns critérios necessários não foram atingidos, e gostaria de destacar os pontos que precisam de atenção:

      Clareza na Apresentação: A apresentação teve algumas partes que não estavam claras, o que dificultou a compreensão do seu trabalho. Tente estruturar melhor as informações na próxima vez.

      Execução Técnica: Algumas técnicas/analises não foram aplicadas corretamente. Sugiro revisar os conceitos e praticar mais antes de aplicar em projetos futuros.

      Documentação: A documentação do processo estava incompleta. É importante detalhar cada etapa, pois isso ajuda na avaliação e no entendimento do seu raciocínio.


      Recomendo que você revise esses pontos e nos envie novamente. Estou aqui para ajudar, caso necessário.
    `,
    helper: "Escolher um dos critérios"
  }
]